import get from "lodash/get";
import React, { useMemo } from "react";
import { add, format, startOfDay } from "date-fns";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Back from "~/components/Icons/arrow-prev2";
import Pagination from "~/components/Pagination";
import Table from "~/components/Table";
import Button from "~/shared/ui/Fields/Button";
import DatesPicker from "~/shared/ui/Fields/DatePicker";
import { useGetLocationData } from "~/hooks/locationData";
import { getFormatDate } from "~/libs/getFormatDate";
import {
  useCreatePeriodRegisterMutation,
  useGetArchivePeriodsQuery,
} from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";

import { PERIOD_OPTIONS } from "./options";

import s from "./DealerPeriod.less";

const DealerPeriod = () => {
  const { t } = useTranslation();

  const { count, page, openModal, currentId } = useGetLocationData();

  const { control, watch } = useForm();

  const isInsideDate = watch("insideDate");
  const history = useHistory();
  const maxDate = useMemo(() => new Date(), []);

  const goInheritance = () => {
    history.replace("/dealers/inheritance/");
  };

  const goBack = () => {
    history.replace("/dealers/");
  };

  const { data, refetch, loading } = useGetArchivePeriodsQuery({
    variables: {
      page,
      count,
      insideDate: isInsideDate
        ? format(
            add(startOfDay(isInsideDate), { hours: 4 }),
            "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"
          )
        : undefined,
    },
  });

  const { notifySuccess } = useNotify();

  // createPeriodRegister
  const [createPeriodRegister, createPeriodRegisterMutation] =
    useCreatePeriodRegisterMutation({
      onCompleted() {
        refetch();
        notifySuccess(t("common.adding_was_successful"));
      },
    });
  const periodData = get(
    data,
    "DealerRegistryGetter.getArchivePeriods.items",
    []
  ).map((el) => {
    return {
      ...el,
      dateStart: getFormatDate(el.dateStart, true),
      dateEnd: getFormatDate(el.dateEnd, true),
      isCreatedByUser: el.isCreatedByUser
        ? "Создана вручную"
        : "Создана автоматически",
      createdAt: getFormatDate(el.createdAt, true),
    };
  });
  const periodTotal = get(
    data,
    "DealerRegistryGetter.getArchivePeriods.total",
    0
  );

  const onAddPeriod = () => {
    createPeriodRegister();
  };

  return (
    <>
      <div className={s.wrapper}>
        <div className={s.s_dealer_title}>{t("dealerPeriod.title")}</div>

        <Button
          txtBtn={"Создать новый период архивации"}
          small
          orange
          onClick={() => onAddPeriod()}
          disabled={createPeriodRegisterMutation.loading}
          loading={createPeriodRegisterMutation.loading}
        />
        <Button
          txtBtn={t("dealers.succession_chain")}
          small
          orange
          onClick={goInheritance}
          disabled={createPeriodRegisterMutation.loading}
          loading={createPeriodRegisterMutation.loading}
        />

        <div className={s.item_date}>
          <div className={s.date}>
            <span className={s.labelDate}>{t("dealerPeriod.insideDate")}</span>
            <DatesPicker
              name={"insideDate"}
              control={control}
              gray
              maxDate={maxDate}
              customClassName={s.item_wite}
              dateFormat={"dd.MM.yyyy"}
            />
          </div>
        </div>
        <Button
          txtBtn={"Назад"}
          onClick={goBack}
          small
          customClassName={s.add_bth}
        >
          <Back />
        </Button>

        <Pagination total={periodTotal}>
          <Table
            options={PERIOD_OPTIONS}
            items={periodData}
            loading={loading}
            sortable={false}
            type={"dealerPeriod"}
            btnDownload
            customClassName={s.dealers_table}
          />
        </Pagination>
      </div>
    </>
  );
};

export default DealerPeriod;
